import {
  AfterViewInit,
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  Input,
  Optional,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ControlContainer,
  FormControlName,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { distinctUntilChanged, tap } from 'rxjs';

@Component({
    selector: 'pr-input',
    templateUrl: './pr-input.component.html',
    styleUrls: ['./pr-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PrInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class PrInputComponent implements AfterViewInit {
  @ContentChild(FormControlName, { static: false }) control: FormControlName;
  @Input() formControlName: string;

  @Input() derrors: boolean = false;
  @Input() required: boolean = false;
  @Input() loading: boolean = false;
  @Input() tooltipButton: string;
  @Input() maskError: string = 'Veuillez respecter le format :';
  @Input() phoneMask: boolean = false;
  @Input() highlightOnValue: boolean = false;
  @Input() highlightOnFocus: boolean = false;

  @Input() label: string;
  @Input() suffix: string;

  hasValue: boolean = false;
  hasFocus: boolean = false;

  @ViewChild('suggestionTooltipTrigger', {
    static: false,
    read: TooltipDirective,
  })
  public suggestionTemplate: TooltipDirective;
  @Input() set suggestion(value: boolean) {
    this._suggestion = value;
    setTimeout(
      () =>
        this._suggestion
          ? this.suggestionTemplate.show()
          : this.suggestionTemplate.hide(),
      0,
    );
  }
  get suggestion(): boolean {
    return this._suggestion;
  }
  _suggestion: boolean = false;
  @Output() suggestionClicked: EventEmitter<any> = new EventEmitter();

  errors: Array<any> = ['This field is required'];

  constructor(@Optional() private controlContainer: ControlContainer) {}

  get formControl(): UntypedFormControl | null {
    if (this.formControlName && this.controlContainer) {
      return this.controlContainer.control?.get(
        this.formControlName,
      ) as UntypedFormControl;
    }
    return (this.control?.control as UntypedFormControl) || null;
  }

  ngAfterViewInit(): void {
    const ctrl = this.formControl;
    if (!ctrl) {
      return;
    }

    ctrl.valueChanges
      .pipe(
        distinctUntilChanged(),
        tap(val => {
          if (val === this.suggestion) {
            this.suggestion = undefined;
          }
          this.hasValue = val && val.toString().trim() !== '';
        }),
      )
      .subscribe(val => {
        if (typeof val === 'string') {
          ctrl.setValue(val.replace(',', '.'), {
            onlySelf: true,
          });
        }
      });

    setTimeout(() => {
      const initialValue = ctrl.value;
      this.hasValue = initialValue && initialValue.toString().trim() !== '';
    }, 0);
  }

  onInputEvent(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target) {
      this.hasValue = target.value && target.value.trim() !== '';
    }
  }
}
